import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({
  breaks: true,
  gfm: true,
});

const VIDEO_PROVIDERS = [
  {
    match: /^https?:\/\/(www\.)?loom\.com\/share\/([a-zA-Z0-9]+)/,
    embed: (match) => `https://www.loom.com/embed/${match[2]}`,
  },
  {
    match: /^https?:\/\/(www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/,
    embed: (match) => `https://www.youtube.com/embed/${match[2]}`,
  },
  {
    match: /^https?:\/\/(www\.)?vimeo\.com\/(\d+)/,
    embed: (match) => `https://player.vimeo.com/video/${match[2]}`,
  },
];

export function getVideoEmbedUrl(url) {
  if (!url) return null;
  for (const provider of VIDEO_PROVIDERS) {
    const match = url.match(provider.match);
    if (match) return provider.embed(match);
  }
  return null;
}

export function renderMarkdown(text) {
  if (!text) return "";

  const cleanHtml = DOMPurify.sanitize(marked.parse(text), {
    ADD_ATTR: ["target", "rel"],
  });

  const container = document.createElement("div");
  container.innerHTML = cleanHtml;

  container.querySelectorAll("a[href]").forEach((anchor) => {
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");

    const embedUrl = getVideoEmbedUrl(anchor.getAttribute("href"));
    if (embedUrl) {
      anchor.classList.add("nixia-video-link");
      anchor.setAttribute("data-embed-url", embedUrl);
      anchor.insertAdjacentHTML("beforeend", ' <i class="fa-solid fa-circle-play"></i>');
    }
  });

  return container.innerHTML;
}
